import { locale, t } from "./i18n/index.ts";

function privacyHref(): string {
  return locale() === "ko" ? "/privacy/ko" : "/privacy/en";
}

function aboutHref(): string {
  return locale() === "ko" ? "/about/ko" : "/about";
}

function termsHref(): string {
  return locale() === "ko" ? "/terms/ko" : "/terms";
}

function contactHref(): string {
  return locale() === "ko" ? "/contact/ko" : "/contact";
}

/** Persistent legal links for the home panel and full-page quest views. */
export function mountLegalFooter(root: ParentNode): void {
  let nav = root.querySelector<HTMLElement>(".site-legal");
  if (!nav) {
    nav = document.createElement("nav");
    nav.className = "site-legal";
    nav.setAttribute("aria-label", t("legal.aria"));
    root.append(nav);
  }
  nav.innerHTML = [
    `<a href="${aboutHref()}" data-i18n="legal.about">${t("legal.about")}</a>`,
    `<a href="${privacyHref()}">${t("legal.privacy")}</a>`,
    `<a href="${termsHref()}" data-i18n="legal.terms">${t("legal.terms")}</a>`,
    `<a href="${contactHref()}" data-i18n="legal.contact">${t("legal.contact")}</a>`,
  ].join('<span class="site-legal-sep" aria-hidden="true">·</span>');
}

export function refreshLegalFooterLinks(): void {
  for (const nav of document.querySelectorAll<HTMLElement>(".site-legal")) {
    const links = nav.querySelectorAll<HTMLAnchorElement>("a");
    if (links.length >= 4) {
      links[0]!.href = aboutHref();
      links[1]!.href = privacyHref();
      links[2]!.href = termsHref();
      links[3]!.href = contactHref();
    }
  }
}
